global.moxie = require('../../../../node_modules/plupload/js/moxie.js');
const plupload = require('../../../../node_modules/plupload/js/plupload.min.js');

/**
 * Wrapper around a plupload instance that only exposes some of its functionality and events.
 * @class
 */
function Uploader() {
  var eventHandlers = {};

  /**
   * Bind to an event of plupload, see its documentation. The parameters of the callback are *not* mapped 1:1, see description
   * below.
   *
   * The following events are mapped with this wrapper with the given parameters:
   * - FilesAdded(Array files) - with the files that were added.
   * - BeforeUpload - no parameters
   * - Error(Object err) - with the plupload error object
   * - FileUploaded(int numberOfFiles - with the total number of files available
   * - FilesRemoved(Array files) - with the files that were removed
   *
   * @param {String} eventName The event name, one of the list above.
   * @param {Function} cb The callback to execute for the given event. See above for what parameters will be passed to the callback.
   */
  this.bind = function(eventName, cb) {
    eventHandlers[eventName] = cb;
  };

  this.executeCallback = function(eventName) {
    if (eventHandlers.hasOwnProperty(eventName)) {
      // first argument is the event name, after that follow the arguments to the callback. `arguments` is not an array so classic trick to splice.
      var args = [].splice.call(arguments, 1);
      eventHandlers[eventName].apply(this, args);
    }
  };
}

Uploader.prototype.setUploaderInstance = function(uploaderInstance) {
  this.uploaderInstance = uploaderInstance;
};

Uploader.prototype.hasFilesToUpload = function() {
  return this.uploaderInstance.total && this.uploaderInstance.total.queued != 0;
};

Uploader.prototype.start = function() {
  this.uploaderInstance.start();
};

Uploader.prototype.removeFile = function(fileName) {
  var self = this;
  if (this.uploaderInstance.files) {
    $.each(this.uploaderInstance.files, function(k, v) {
      if (v && v.name === fileName) {
        self.uploaderInstance.removeFile(v);
      }
    });
  }
};

angular.module('cfn').service('fieldImportWizardService', [
  '$filter',
  'userSettingsService',
  function($filter, userSettingsService) {
    var uploader = new Uploader();

    function analyzeFiles(fileNames) {
      var shpFormat = null,
        xmlFormat = null;

      if (!fileNames || fileNames.length > 0) {
        var fileTypes = _(fileNames).map(function(file) {
            var fileName = file.toLowerCase();
            return fileName.substr(fileName.length - 4);
          }),
          fileCount = fileNames.length,
          firstFileName = fileNames[0].substr(0, fileNames[0].length - 4),
          isNotAllSameFilenames = _(fileNames).reduce(function(
            memoIsNotSame,
            fileName
          ) {
            var isNotSame =
              firstFileName !== fileName.substr(0, fileName.length - 4);
            return memoIsNotSame || isNotSame;
          },
          false);

        // --- Shape Method: ---
        // User uploads a combination of *.shx, *.dbf, *.shp files
        shpFormat = (function() {
          var neededFiletypes = ['.shx', '.dbf', '.shp'];
          var hasNeededFiletypes =
            _(neededFiletypes).difference(fileTypes).length === 0;
          var hasPrjFile = _(fileTypes).contains('.prj');
          var hasAny =
            hasPrjFile ||
            _(neededFiletypes).difference(fileTypes).length <
              neededFiletypes.length;
          var neededFileCount = neededFiletypes.length;

          return hasAny
            ? {
                isValid:
                  ((hasNeededFiletypes && fileCount === neededFileCount) ||
                    (hasPrjFile && fileCount === neededFileCount + 1)) &&
                  !isNotAllSameFilenames
              }
            : null;
        })();
        // --- XML Method: ---
        // User uploads just one *.xml or gml-file
        xmlFormat = (function() {
          var hasNeededFiletypes =
            _(fileTypes).contains('.xml') || _(fileTypes).contains('.gml');

          return hasNeededFiletypes
            ? {
                isValid: hasNeededFiletypes && fileNames.length === 1
              }
            : null;
        })();
      }

      var result = {
        _all: ['SHP', 'XML'],
        SHP: shpFormat,
        XML: xmlFormat,
        getType: function() {
          if (result.SHP && result.XML) {
            return 'SHP,XML';
          }
          if (result.SHP) {
            return 'SHP';
          }
          if (result.XML) {
            return 'XML';
          }
          return null;
        },
        isValid: function() {
          return (
            result.getType() !== null &&
            result[result.getType()] &&
            result[result.getType()].isValid
          );
        }
      };
      return result;
    }

    /**
     * Legacy function from the fieldImportWizardController, left from refactoring. Contains logic on how many and which
     * files (by file extension) are needed.
     *
     * @returns {*} An error message or null if there was no error.
     */
    this.checkFiles = function() {
      var up = uploader.uploaderInstance;
      var analysisResult = analyzeFiles(_(up.files).pluck('name'));
      var hasError = !analysisResult.isValid();

      if (hasError) {
        console.log('Stopping upload, Error found');
        up.stop();
        plupload.each(up.files, function(fileBack) {
          fileBack.status = plupload.QUEUED;
        });
        up.refresh();
      }

      return analysisResult;
    };

    function getFileTypesByCountry() {
      var supportedFileTypes = 'shp,dbf,prj,shx';
      if (
        ['DEU', 'FRA'].indexOf(userSettingsService.getIsoCountryEnum()) !== -1
      ) {
        supportedFileTypes += ',xml,gml';
        return supportedFileTypes;
      } else {
        return supportedFileTypes;
      }
    }

    /**
     * Init a plupload wrapper.
     * For legacy reasons the returned instance is NOT immediately usable. Since it's usually used in a file upload dialog
     * the user will spent enough time clicking so the initialization will be complete as soon as it is needed.
     *
     * @param uploadId The id to use for all uploads, will be sent in the header 'uploadId' for each upload.
     * @returns {Uploader} A wrapped plupload instance.
     */
    this.initUploader = function(uploadId) {
      // Lazy load the plupload library only when it's actually needed.
      var uploaderInstance = new plupload.Uploader({
        runtimes: 'html5',
        browse_button: 'pickfiles',
        container: 'container',
        max_file_size: '5mb',
        unique_names: false,
        url: '/365FarmNet/rest/fieldimport/upload',
        filters: {
          mime_types: [
            { title: 'Shapefile', extensions: getFileTypesByCountry() }
          ],
          prevent_duplicates: true
        },
        multi_selection: true,
        headers: {
          uploadId: uploadId,
          'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
        }
      });
      uploaderInstance.init();
      uploader.setUploaderInstance(uploaderInstance);

      // Event delegation for interesting events while encapsulating the plupload instance.
      // This is also necessary to make event binding for the wrapped instance available before initUploader has finished.
      uploaderInstance.bind('FilesAdded', function(up, files) {
        uploader.executeCallback('FilesAdded', files);
      });

      uploaderInstance.bind('BeforeUpload', function() {
        uploader.executeCallback('BeforeUpload');
      });

      uploaderInstance.bind('Error', function(up, err) {
        uploader.executeCallback('Error', err);
      });

      uploaderInstance.bind('FileUploaded', function(up, file, response) {
        uploader.executeCallback('FileUploaded', up.files, file, response);
      });

      uploaderInstance.bind('FilesRemoved', function(up, files) {
        uploader.executeCallback('FilesRemoved', files);
      });

      return uploader;
    };
  }
]);
